<template>
  <div class="auth-background">
    <div class="auth-layout">
      <router-view/>
    </div>
    <div class="build-number">{{buildNumber}}</div>
  </div>
</template>

<script>
export default {
  name: 'auth',
  data () {
    return {
      buildNumber: 'Сборка: ' + process.env.VUE_APP_BUILD_NUMBER
    }
  }
}
</script>

<style lang="scss">
.auth-background {
  height: 100%;
  width: 100%;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  position: absolute;
  background: #383F50;
}

.auth-layout {
  max-width: 300px;
  margin: 5vh auto 0 auto;
  padding: 32px 32px 20px 32px;

  border-radius: 16px;
  background-color: #fff;
  box-shadow: 0 20px 40px 0 rgba(0,0,0,.5);
  overflow: hidden;
  transition: height .2s ease-in;
}
.build-number {
  position: fixed;
  bottom: 0;
  padding-bottom: 5px;
  width: 100%;

  font-size: 12px;
  color: #fff;
  text-align: center;
}
</style>
